export const MessageModule = 'messages';
export const messageMutations = {
  SET_MESSAGES: 'SET_MESSAGES',
};
export const messageActions = {
  GET_USER_MESSAGES: 'GET_USER_MESSAGES',
};
